import { ProductImage } from "~/components/product-list/product-image";
import type { C_ProductInfo } from "~/lib/app.types";
import { cn } from "~/lib/ui";
import { getVariantImage } from "~/shop/utils/image";

const SIZE_CLASS: Record<"xs" | "medium" | "large", string> = {
  xs: "h-18 w-18",
  medium: "h-32 w-32",
  large: "h-40 w-40",
};

export const ProductListingImage = ({
  product,
  size = "large",
  className,
}: {
  product: C_ProductInfo | undefined;
  size?: "xs" | "medium" | "large";
  className?: string;
}) => {
  if (!product) return null;
  // Pass the product's own `variationValues` so `getVariantImage` picks the
  // matching variant's image group instead of falling back to the first large
  // group (master default). Without this, a cart row that just swapped from
  // one variant to another keeps the OLD variant image even after the basket
  // updates — same productId, but `imageGroups` is keyed by variation attrs.
  const selection =
    (product.variationValues as Record<string, string> | undefined) ??
    undefined;
  const [image] = getVariantImage(product, selection) ?? [];
  if (!image) return;
  return (
    <div
      className={cn(
        "flex-shrink-0 overflow-hidden rounded-lg border border-gray-200",
        SIZE_CLASS[size],
      )}
    >
      <ProductImage
        image={{ ...image, alt: product.name }}
        type="cart"
        className={className}
      />
    </div>
  );
};
